import React from 'react'
import { useDispatch, useSelector } from 'hooks'
import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import { userThumbType } from 'common/types'
import { like } from 'store/actions'

import StyledUserThumb, { StyledStatusPanel, StyledUserInfo } from './StyledUserThumb'

const UserThumb = ({ user, inverted, Extra }) => {
  const { location, nickname, inHotlist, mediaItemsCount } = user
  const placeholder = !nickname
  const dispatch = useDispatch()
  const vipEnabled = useSelector(s => s.siteConfig?.features.vipEnabled || s.flags.vip)
  const secondPersonAge = user?.members?.[1] ? ` & ${user.members[1].age}` : ''

  return (
    <StyledUserThumb to={nickname ? `/members/${nickname}` : ''}>
      <div className="avatar">
        <Avatar user={user} inverted={inverted} />
        {!placeholder && (
          <StyledStatusPanel vipEnabled={vipEnabled} inHotlist={inHotlist}>
            <div className="image-amount">
              <Icon name="camera" size="small" />
              {mediaItemsCount}
            </div>
            <div
              className="member-hot"
              onClick={e => {
                e.preventDefault()
                dispatch(like(user))
              }}
            />
          </StyledStatusPanel>
        )}
      </div>
      <StyledUserInfo>
        <div className="username-age">
          {!placeholder && (
            <>
              <span className="username">{user.screenName}</span>
              <span className="age">{user.members[0].age + secondPersonAge}</span>
            </>
          )}
        </div>
        <p className="city-country">
          {!placeholder && (
            <>
              <span className="UserThumb__city">{location.city.name}</span> | <span>{location.country.name}</span>
            </>
          )}
        </p>
      </StyledUserInfo>
      {Extra && <Extra user={user} />}
    </StyledUserThumb>
  )
}

UserThumb.defaultProps = {
  inverted: false,
  user: {},
}

UserThumb.propTypes = userThumbType

export default UserThumb
